import PhoneVerifyModal from "app/components/PhoneVerifyModal/PhoneVerifyModal";

export default PhoneVerifyModal;